module.exports = __webpack_public_path__ + "static/media/BLUSH_6752.9096fa11.jpg";